var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWatchRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.304199 5.26267C0.304199 3.94143 0.84186 2.67431 1.7989 1.74006C2.75594 0.805804 4.05397 0.280945 5.40743 0.280945H19.016C20.3695 0.280945 21.6675 0.805804 22.6246 1.74006C23.5816 2.67431 24.1193 3.94143 24.1193 5.26267V18.5473C24.1193 19.8685 23.5816 21.1356 22.6246 22.0699C21.6675 23.0041 20.3695 23.529 19.016 23.529H13.3106C14.0346 22.9056 14.6144 22.139 15.0115 21.2801C15.4086 20.4212 15.6139 19.4896 15.6139 18.5473V15.2261C15.6139 13.4645 14.897 11.775 13.621 10.5293C12.3449 9.28363 10.6142 8.58382 8.80958 8.58382H5.40743C4.4421 8.58377 3.4878 8.78423 2.60793 9.17189C1.72807 9.55955 0.942767 10.1255 0.304199 10.8322V5.26267ZM5.40743 10.2444C4.05397 10.2444 2.75594 10.7693 1.7989 11.7035C0.84186 12.6378 0.304199 13.9049 0.304199 15.2261V18.5473C0.304199 19.8685 0.84186 21.1356 1.7989 22.0699C2.75594 23.0041 4.05397 23.529 5.40743 23.529H8.80958C10.163 23.529 11.4611 23.0041 12.4181 22.0699C13.3752 21.1356 13.9128 19.8685 13.9128 18.5473V15.2261C13.9128 13.9049 13.3752 12.6378 12.4181 11.7035C11.4611 10.7693 10.163 10.2444 8.80958 10.2444H5.40743Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchRoom);
export default __webpack_public_path__ + "static/media/watchRoom.0a68fbcb44941a62bc0793d0dc4d1fe6.svg";
export { ForwardRef as ReactComponent };